/*
 * Copyright (c) 2025-2026.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import React, {Component} from 'react';
import {Database} from "../APIClient.jsx";
import RowDataTable from "./RowDataTable.jsx";
import DisplayIcon from "./Icons/DisplayIcon.jsx";
import ElementStatus from "./ElementStatus.jsx";
import IconButtonComponent from "./BasicInputs/IconButtonComponent.jsx";
import {UI} from "../UIGenerator.jsx";
import EmptyStateBig from "./EmptyState/EmptyStateBig.jsx";
import TextElement from "./TextElement.jsx";
import ButtonComponent from "./BasicInputs/ButtonComponent.jsx";
import {Socket} from "../Socket.js";
import {Subscription} from "../Subscription.js";
import {Util} from "../Utilities.js";
import Domains from "../Objects/Domains.jsx";
import AddDomain from "./AddDomain.jsx";

class ElementDomains extends Component {
    constructor() {
        super();
        this.state = {
            allDomains: []
        }
        this.sub = new Subscription()
    }

    async fetchData() {
        let {elementId} = this.props
        let allDomains = await Database.table("Domains", "app").simpleFilter("targetIndexKey", elementId)
        this.setState({allDomains: allDomains.recordset})

        this.sub.add(() => Database.table("Domains", "app").onChange((change) => {
            let allDomains = this.state.allDomains
            allDomains = Socket.applyChange(allDomains, change)

            this.setState({allDomains: allDomains})
        }, [{
            column: "targetIndexKey",
            value: elementId
        }]), "liveData")
    }

    componentDidMount() {
        this.fetchData()
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.elementId !== this.props.elementId) {
            this.fetchData()
        }
    }

    componentWillUnmount() {
        this.sub.unmount()
    }

    addDomain() {
        let {elementType, elementId} = this.props
        let drawerId = Util.unique.newInternalId()


        UI.drawer(drawerId, (state, setState, close) => {
            return (<div className={"py-2 space-y-2"}>

                <AddDomain elementId={elementId} close={close}/>
            </div>)

        }, (state, close) => {
            close()
        }, {
            title: "Add Domain", button: [{
                type: "abort",
                text: "Abbrechen",
                onClick: (inputState, setState, close) => {
                    close()
                }
            }]
        }).open({
            indexKey: "",
            domainName: "",
        })


    }

    render() {
        let {allDomains} = this.state
        return (
            <div>
                <ButtonComponent text={"Add domain "} onClick={() => {
                    this.addDomain()
                }}/>

                <div className={"mt-2"}>
                    <RowDataTable
                        selectedIndex={this.state.selectedIndex}
                        iconElement={(row) => {
                            return (<div
                                className={`flex-shrink-0  p-1 flex justify-center items-center rounded  border mr-3 `}>
                                <DisplayIcon iconName={"PiSignpost"} size={"1.1rem"}/>
                            </div>)
                        }}
                        buttons={(row) => {
                            return <>

                                <IconButtonComponent text={`Open URL`}
                                                     iconName={"IoEyeOutline"}
                                                     onClick={() => {
                                                         // open the page
                                                         UI.page().navigateNewTab({
                                                             pathname: "https://" + row.domainName,
                                                         })
                                                     }}/>

                                <IconButtonComponent text={`Remove URL`}
                                                     iconName={"IoTrash"}
                                                     onClick={async () => {
                                                         await Domains(row.indexKey).remove()
                                                     }}/>


                                <ElementStatus name={"Domains"} elementId={row.indexKey}/>

                            </>

                        }}
                        data={allDomains.map(item => ({
                            ...item,
                            Name: <>{item.domainName} </>

                        }))}
                        emptyState={() => {
                            return (<><EmptyStateBig iconName={"IoIosSearch"}
                                                     text={<div className={"w-96 space-y-3"}>
                                                         <TextElement
                                                             textType={"header-lg"}> Keine test mit
                                                             dem Namen: "<span
                                                                 className={"italic"}>{this.state.searchinput}</span>"
                                                             gefunden</TextElement>

                                                         <ButtonComponent iconName={"IoAdd"}
                                                                          onClick={() => {
                                                                              //AppActions.layout.newLayout()
                                                                          }}
                                                                          text={`Neue  `}/>
                                                     </div>}/></>)

                        }}
                        progressPending={!this.state.isLoadedComplete}
                        onRowClicked={(data) => {

                        }}
                        onMiddleMouseClick={(data) => {
                        }}
                    />
                </div>


            </div>
        );
    }
}

ElementDomains.propTypes = {};

ElementDomains.defaultProps = {};


export default ElementDomains;